import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { timeout } from '@/utils/common'

const ajuda = [
  {
    id: '1d96658d-8d9e-462f-98d5-954d528501c3',
    titulo: 'Cirurgias favoritas',
    documento: 'https://finxstsfrontstaticfiles.blob.core.windows.net/guias-de-uso/Guia-de-uso-Salve-suas-cirurgias-favoritas.pdf',
  },
  {
    id: '656a9d58-8770-45b0-9ca8-7c7c72913643',
    titulo: 'Associação de secretária',
    documento: 'https://finxstsfrontstaticfiles.blob.core.windows.net/guias-de-uso/Guia-de-uso-Associação-de-Secretária.pdf',
  },
]

@Module({ namespaced: true, name: 'AjudaStore' })
export default class AjudaStore extends VuexModule {
  private faqsDefault: Array<{ titulo: string, documento: string }> = []
  public faqs: Array<{ titulo: string, documento: string }> = [...this.faqsDefault]

  @Mutation
  setFaqs(faqs: Array<{ titulo: string, documento: string }>) {
    this.faqs = faqs
  }

  @Mutation
  clearFaqs() {
    this.faqs = []
  }

  @Action
  async getFaqs() {
    await timeout(300)
    this.setFaqs(ajuda)
  }
}
